import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '../../contexts/PermissionsContext';
import AdminLandingPage from '../../pages/AdminLandingPage';

const ProtectedAdminLanding: React.FC = () => {
  const navigate = useNavigate();
  const { canCreateAgents } = usePermissions();

  useEffect(() => {
    if (!canCreateAgents) {
      navigate('/admin/overview', { replace: true });
    }
  }, [canCreateAgents, navigate]);

  // Se não pode criar agentes, não renderiza nada (vai redirecionar)
  if (!canCreateAgents) {
    return null;
  }

  return <AdminLandingPage />;
};

export default ProtectedAdminLanding;
